import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-text">
        <p>Copyright &copy; 2024 by @DamithWijekoon | All Rights Reserved</p>
      </div>
      <div className="footer-iconTop">
        <a href="#home"><i className="fa-solid fa-angle-up"></i></a>
      </div>
    </footer>
  );
};

export default Footer;
